import React from 'react';
import { Box, Link } from '@mui/material';
import Copy from 'components/common/Copy';
import { CarModel } from 'models/StockModel';


type CopyableChassisProps = {
    car: CarModel,
    query?: string,
}

const CopyableChassis = ({car, query = ''}: CopyableChassisProps) => {
    return (
        <>
            <Copy value={car.chassisNumber} space/>
            <Box sx={{textOverflow: 'ellipsis', overflow: 'hidden'}}>
                <Link href={`/car/${car.id}${query}`}>{car.chassisNumber}</Link>
            </Box>
        </>
    );
};

export default CopyableChassis;
